// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4423d2a9","455":"5076c0ff","977":"3c5f3618"}[chunkId] + ".chunk.js";
};